document.addEventListener("DOMContentLoaded", function() {
    function initTabs() {
        if (window.innerWidth < 768) return; // Mobile par run nahi hoga

        let tabs = document.querySelectorAll('.block__tab--heading');
        let contents = document.querySelectorAll('.block__right_content');

        if (tabs.length > 0 && contents.length > 0) {
            tabs[0].classList.add('active_heading');
            contents[0].classList.add('tab-active');
        }

        tabs.forEach(function(tab) {
            tab.addEventListener('click', function(event) {
                event.preventDefault();

                let targetId = this.getAttribute('data-id');

                contents.forEach(function(content) {
                    content.classList.remove('tab-active');
                });

                let targetContent = document.querySelector('.block__right_content[data-id="'+ targetId +'"]');
                if (targetContent) {
                    targetContent.classList.add('tab-active');
                }

                tabs.forEach(function(link) {
                    link.classList.remove('active_heading');
                });

                this.classList.add('active_heading');
            });
        });
    }

    initTabs();

    // Resize event listener to reinitialize if needed
    window.addEventListener('resize', function() {
        if (window.innerWidth >= 768) {
            initTabs();
        }
    });
});


document.addEventListener("DOMContentLoaded", function () {
    const tabHeadings = document.querySelectorAll(".block__tab--heading");
    const contentBlocks = document.querySelectorAll(".block__right_content--mobile");

    let activeTab = null; // Track the currently active tab

    if (contentBlocks.length > 0) {
        // Open the first content block and set the first tab as active
        contentBlocks[0].style.display = "block";
        const firstTabId = contentBlocks[0].getAttribute("data-id");
        tabHeadings.forEach((tab) => {
            if (tab.getAttribute("data-id") === firstTabId) {
                tab.classList.add("active_heading");
                activeTab = firstTabId; // Set first tab as active
            }
        });
    }

    tabHeadings.forEach((heading) => {
        heading.addEventListener("click", function () {
            const targetId = this.getAttribute("data-id");
            const correspondingContent = document.querySelector(`.block__right_content--mobile[data-id="${targetId}"]`);

            if (activeTab === targetId) {
                // If the clicked tab is already active, close it
                this.classList.remove("active_heading");
                correspondingContent.style.display = "none";
                activeTab = null;
            } else {
                // Update tab headings
                tabHeadings.forEach((tab) => {
                    tab.classList.remove("active_heading");
                });
                this.classList.add("active_heading");

                // Update content blocks
                contentBlocks.forEach((content) => {
                    content.style.display = "none";
                });
                correspondingContent.style.display = "block";

                activeTab = targetId; // Set new active tab
            }
        });
    });
});



  // start protocol page video button popup

  document.addEventListener("DOMContentLoaded", function () {
    const popupWrapper = document.querySelector(".block__protocols-tab--popup");
    const body = document.body;

    // Store Vimeo player instances
    const vimeoPlayers = new Map();

    // Initialize Vimeo players
    document.querySelectorAll("iframe.js-vimeo").forEach(iframe => {
        const player = new Vimeo.Player(iframe);
        vimeoPlayers.set(iframe, player);
    });

    // Open video popup
    document.querySelectorAll(".open-video-btn").forEach(btn => {
        btn.addEventListener("click", function () {
            const targetId = this.getAttribute("data-target");
            const targetPopup = document.getElementById(targetId);

            // Hide all popups
            document.querySelectorAll(".video-popup").forEach(p => p.classList.add("hidden"));

            // Show selected popup
            popupWrapper.classList.remove("hidden");
            targetPopup.classList.remove("hidden");
            body.classList.add("overflow-hidden");
        });
    });

    // Function to close popup and pause videos
    const closePopupAndPauseVideos = () => {
        popupWrapper.classList.add("hidden");
        document.querySelectorAll(".video-popup").forEach(p => p.classList.add("hidden"));
        body.classList.remove("overflow-hidden");

        // Pause all videos
        document.querySelectorAll("iframe").forEach(iframe => {
            // Pause YouTube
            if (iframe.classList.contains("js-youtube")) {
                iframe.contentWindow.postMessage(
                    '{"event":"command","func":"pauseVideo","args":""}', '*'
                );
            }

            // Pause Vimeo
            if (iframe.classList.contains("js-vimeo")) {
                const player = vimeoPlayers.get(iframe);
                if (player) {
                    player.pause().catch(err => {
                        console.warn("Vimeo pause failed:", err);
                    });
                } else {
                    console.warn("Vimeo player not found for iframe:", iframe);
                }
            }
        });
    };

    // Close buttons
    document.querySelectorAll(".close-video").forEach(btn => {
        btn.addEventListener("click", closePopupAndPauseVideos);
    });

    // Close on overlay click
    popupWrapper.addEventListener("click", (e) => {
        if (e.target === popupWrapper) {
            closePopupAndPauseVideos();
        }
    });
});

  
  // end protocol page video button popup